import React, { useEffect, useState } from "react";
import { Navigate, NavLink } from "react-router-dom";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import { useCheckoutContext } from "../../../context/checkout/CheckoutContext";
import { Address, CartEntity } from "../../../models/cartData";
import { Data } from "../../../models/checkoutData";
import CheckoutLineItem from "./LineItemCheckout";
import { RetryOrder } from "./RetryOrder";
import useRazorpay, { RazorpayOptions } from "../../../utils/RazorpayType";
import CheckoutSkeleton from "../../../components/CheckoutSkeleton";
import AquaLoader from "../../../components/AquaLoader";
import AquaCodLoader from "../../../components/AquaCodLoader";

interface CheckoutDataProps {
  data: Data;
}

interface cartdataProps {
  data: CartEntity[];
}

interface createOrderDataPops {
  payment_mode: string;
  total: any;
  razorpay_customer_id?: string | undefined;
  cart_id: number | undefined;
  razorpay_payment_id?: any;
  razorpay_order_id?: any;
  razorpay_signature?: any;
}
interface createWalletOrderDataProps{
  payment_mode: string;
  total: any;
  razorpay_customer_id?: string | undefined;
  cart_id: number | undefined;
  razorpay_payment_id?: any;
  razorpay_order_id?: any;
  razorpay_signature?: any;
}

export const Checkout: React.FC = () => {
  const {
    emptyCart,
    updateCartItem,
    fetchCart,
    getCartData,
    modalOpenData,
    statusData,
    openPopup,
    closePopup,
    setPageData,
  } = useShoppingCart();
  const [show, setShow] = useState(false);
  const {
    createCart,
    createRazorOrder,
    razorOrderData,
    checkoutData,
    getOrderStatus,
    createShopifyOrder,
    orderStatus,
    shopifyOrderData,
    setRazorDataFunction,
    setOrderStatusFunction,
    getCheckoutError,
    setCheckoutError,
    setStatusFlagFunction,
    statusFlagData
    
  } = useCheckoutContext();

  // createRazorOrder
  const [isRazorOrder, setRazorOrder] = useState(false); // loader flag prepaid

  const [isShopifyOrder, setIsShopifyOrder] = useState(false); // loader flag cod

  const [isLoading, setIsLoading] = useState(true);

  const [isRazorpayOpened, setIsRazorpayOpened] = useState(false);
  const cartLenght = checkoutData?.data.cart?.length;
  const address: any = getCartData?.data[0].address;
  const cart = checkoutData?.data.cart;
  const billing_data = getCartData?.data[0].billing_data.total;
  const cart_id = checkoutData?.data.cart_id;
  const razor_customer = checkoutData?.data.razor_customer;
  const rzp_key = checkoutData?.data.rzp_key;
  const payment_mode = checkoutData?.data.payment_mode;
  const total = checkoutData?.data.total;
  const is_cod = getCartData?.data[0].is_cod;
  const lenskart_order_id = orderStatus?.Status.lenskart_order_id;
  const delivery_date = orderStatus?.Status.delivery_date;
  const created_at = orderStatus?.Status.created_at;
  const id = orderStatus?.Status.id;
  const status = orderStatus?.Status.status;

  // console.log(typeof status, status, "app status");
  // console.log(orderStatus);

  let statusCount: number = 30;
  // let statusFlag: number = 1;

  let shopifyOrderId;
  if (shopifyOrderData?.ShopifyOrder.order.id !== null) {
    shopifyOrderId = shopifyOrderData?.ShopifyOrder.order.id;
  }

  useEffect(() => {
    if (checkoutData) {
      setIsLoading(false);
    }
  }, [checkoutData]);

  useEffect(() => {
    if (getCheckoutError) {
      setIsLoading(false);
    }
  }, [getCheckoutError]);

  useEffect(() => {
    if (razorOrderData) {
      setRazorOrder(false);
    }
  }, [razorOrderData]);

  useEffect(() => {
    if (orderStatus?.Status.lenskart_order_id !== null) {
      setIsShopifyOrder(false);
    }
  }, [orderStatus?.Status.lenskart_order_id]);

  // console.log(modalOpenData, "hshgdfdhsgf jkhfjdsfh");

  const Razorpay = useRazorpay();
  const initPayment = (data: any, amount:any) => {
    setIsRazorpayOpened(true);
    let razorAmount = data.razorData!.amount;
    razorAmount = razorAmount / 100;
    const options: RazorpayOptions = {
      key: rzp_key!,
      amount: razorAmount,
      name: "Aqualens",
      order_id: data.razorData!.id,
      retry: { enabled: true, max_count: true },
      currency: data.razorData!.currency,
      send_sms_hash: true,
      handler: (response) => {
        const createOrderData: createOrderDataPops = {
          payment_mode: "razorpay",
          total: amount,
          razorpay_customer_id: razor_customer,
          cart_id: cart_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        };
        // createShopfyOrder(createOrderData);
        setIsShopifyOrder(true);
        createShopifyOrder(createOrderData);
        
      },
      /**
       * You can track the modal lifecycle by * adding the below code in your options
       */
      modal: {
        ondismiss: () => {
          // setIsRazorpayOpened(false);
          setRazorDataFunction();
          setIsRazorpayOpened(false);
          //remove overflow : hidden from body
          document.body.style.overflow = "";
        },
        confirm_close: true,
        handleback: true,
        escape: true,
      },
      prefill: {
        name: address.first_name,
        contact: address.phone,
        email: address.email,
      },
    };
    const rzp1 = new Razorpay(options);
    rzp1.on("payment.failed", () => {
      setRazorDataFunction();
      setIsRazorpayOpened(false);
      //remove overflow : hidden from body
      document.body.style.overflow = "";
    });
    rzp1.open();
    // console.log(data, "data");
  };
  // console.log(isRazorpayOpened, "isRazorpayOpened");
  // console.log(razorOrderData,isRazorpayOpened);
  let codTotal:any = total;

  if (razorOrderData && !isRazorpayOpened) {
    initPayment(razorOrderData,codTotal);
  }

 
  codTotal = codTotal;

  const createOrderData: createOrderDataPops = {
    payment_mode: "cod",
    total: codTotal,
    cart_id: cart_id,
  };

  const createWalletOrderData: createWalletOrderDataProps ={
    payment_mode: "wallet",
    total: 0,
    cart_id: cart_id,
  }


  let currentURL = "";
  // Accessing the URL
  currentURL = window.location.href;
  // console.log(currentURL, "thankyou");
  function retryOrder() {
    // Redirect to the previous URL
    window.history.back();
  }

  // console.log(statusFlagData,orderStatus);
  if (orderStatus && orderStatus !== undefined) {
    // if (
    //   lenskart_order_id === null &&
    //   status !== "CANCELLED"
    // ) {
    //   // statusFlagData = statusFlagData + 1;
    //   // console.log(statusFlagData)
    //   // debugger
    //   // getOrderStatus(shopifyOrderId);
    //   // console.log(orderStatus?.Status.status, "orderStatus");

    //   return (
    //     <Navigate replace to="/thankyou" />
    
    //   );
      
    // } else 
    if (lenskart_order_id === null || status === "CANCELLED") {
      console.log("satya");
      return (
        <Navigate replace to="/thankyou" />
    
      );
    } else {
      return (
        <Navigate replace to="/thankyou" />
        // <Thankyou lenskart_id={lenskart_order_id} delivery_date={delivery_date} created_at={created_at} status={status} />
      );

    }
  }
  return (
    <>
      {isShopifyOrder && <AquaCodLoader />}

      {isRazorOrder && <AquaLoader />}
      

      <div className="checkoutContainer pb-24" style={{ margin: "auto" }}>
        {/* <CheckoutSkeleton cards={2} /> */}
        {getCheckoutError === "" && <CheckoutSkeleton cards={3} />}

        {cartLenght && getCheckoutError === "success" && (
          <div className="checkoutContent">
            <div className={show ? "checkoutScroll" : "checkoutNoScroll"}>
              <button
                className="popupClose"
                onClick={() => {
                  if (modalOpenData.popupId === "checkout") {
                    closePopup();
                    setPageData(1);
                  } else if (currentURL.includes("thankyou")) {
                    retryOrder();
                    setPageData(1);
                  } else {
                    closePopup();
                  }
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.99032 0.990242C1.79139 0.990294 1.59699 1.04967 1.43198 1.16079C1.26697 1.2719 1.13884 1.4297 1.06399 1.61401C0.98913 1.79832 0.970941 2.00077 1.01175 2.19548C1.05255 2.39018 1.15049 2.56829 1.29305 2.70704L6.58602 8.00001L1.29305 13.293C1.19708 13.3851 1.12046 13.4955 1.06767 13.6176C1.01489 13.7397 0.987001 13.8712 0.985647 14.0042C0.984294 14.1373 1.0095 14.2692 1.05979 14.3924C1.11008 14.5156 1.18444 14.6275 1.27852 14.7216C1.3726 14.8157 1.4845 14.89 1.60768 14.9403C1.73086 14.9906 1.86283 15.0158 1.99587 15.0144C2.12891 15.0131 2.26034 14.9852 2.38247 14.9324C2.5046 14.8796 2.61497 14.803 2.70712 14.707L8.00008 9.41407L13.2931 14.707C13.3852 14.803 13.4956 14.8796 13.6177 14.9324C13.7398 14.9852 13.8713 15.0131 14.0043 15.0145C14.1373 15.0158 14.2693 14.9906 14.3925 14.9403C14.5157 14.89 14.6276 14.8157 14.7217 14.7216C14.8157 14.6275 14.8901 14.5156 14.9404 14.3924C14.9907 14.2692 15.0159 14.1373 15.0145 14.0042C15.0132 13.8712 14.9853 13.7397 14.9325 13.6176C14.8797 13.4955 14.8031 13.3851 14.7071 13.293L9.41415 8.00001L14.7071 2.70704C14.8516 2.56658 14.9503 2.38574 14.9903 2.18822C15.0302 1.9907 15.0096 1.78571 14.931 1.60013C14.8525 1.41454 14.7197 1.25701 14.5501 1.14818C14.3805 1.03935 14.182 0.984302 13.9806 0.990242C13.7208 0.997983 13.4742 1.10656 13.2931 1.29298L8.00008 6.58595L2.70712 1.29298C2.61393 1.19718 2.50248 1.12104 2.37937 1.06904C2.25625 1.01704 2.12396 0.99025 1.99032 0.990242Z"
                    fill="#4F4F4F"
                  ></path>
                </svg>
              </button>
              <div className="checkoutWrapper mx-4">
                {/* <Stepper /> */}

                {/* cart details */}
                <div className="my-12">
                  <div className="flex gap-4">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#469DA1"
                        strokeWidth="4"
                      />
                    </svg>

                    <div className="flex items-center gap-2">
                      <span className="textAqua">Aqualens Home</span>
                      {/* <svg
                        width="4"
                        height="4"
                        viewBox="0 0 4 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="2" cy="2" r="2" fill="#AEAEAE" />
                      </svg>
                      <span className="textShipping">Shipping in 4 Days</span> */}
                    </div>
                  </div>

                  <div className="border-left" style={{ marginLeft: 10 }}>
                    <div
                      className="flex items-baseline gap-3 object-contain"
                      onClick={() => setShow(!show)}
                    >
                      <h1 className="itemSummary">{cartLenght} Items</h1>
                      <svg
                        width="14"
                        height="7"
                        viewBox="0 0 14 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.2802 0.966553L7.93355 5.31322C7.42021 5.82655 6.58021 5.82655 6.06688 5.31322L1.72021 0.966553"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div
                      style={{
                        maxHeight: "calc(100vh - 450px)",
                        overflow: "auto",
                        padding: "0 16px 0 0",
                      }}
                    >
                      {cart &&
                        cart.map((item) => (
                          <div key={item.id}>
                            <CheckoutLineItem
                              item_image={item.item_image}
                              title={item.product_title}
                              subtitle={item.subtitle}
                              price={item.price}
                              variant_title={item.variant_title}
                              show={show}
                            />
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="flex gap-4">
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="#469DA1"
                          strokeWidth="4"
                        />
                      </svg>
                    </div>
                    <div className="deliveryTo flex items-baseline justify-between flex-1">
                      <div className="">
                        <p className="customerName">{address.first_name}</p>
                        <p className="customerAddress">
                          {address.address}, {address.city}, {address.zip_code}
                        </p>
                        <p className="customerPhone">{address.phone}</p>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="billDetails mx-4 p-4">
                <div className="billDetailsText mb-4 flex justify-between items-baseline">
                  <span>Billing Details</span>
                </div>
                <div className="billTotal flex justify-between items-baseline">
                  <p>Total Payable Amount</p>
                  <p>Rs. {billing_data}</p>
                </div>
              </div>

              <div className="placeOrder">
                <button
                  className="placeOrderCTA ripple"
                  onClick={() => {
                    if (is_cod === 1) {
                      createShopifyOrder(createOrderData);
                      setIsShopifyOrder(true);
                    } else if(total === 0 ){
                      createShopifyOrder(createWalletOrderData);
                      setIsShopifyOrder(true);
                    }else {
                      createRazorOrder(cart_id);
                      setRazorOrder(true);
                    }
                  }}
                  disabled={cartLenght ? false : true}
                >
                  <span>
                    {is_cod == 1 ? "Proceed To Order" : "Proceed To Payment"}
                  </span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4301 5.93005L20.5001 12.0001L14.4301 18.0701"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M3.5 12H20.33"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
        {/* payment options */}
        {/* <PlaceOrderCTA buttton_text={is_cod == 1 ? 'Proceed To Order' : 'Proceed To Payment'} cart_id={cart_id} onPress={is_cod == 1 ? () => createShopifyOrder(createOrderData) : createRazorOrder} /> */}
      </div>
    </>
  );
};
